import React from 'react';
import { Table, Space } from 'antd';
import getRouteColumns from './routeColumns';
import { RouteTableRow } from '../../Types/RouteDetails.types';

interface RouteLocationsTableProps {
  tableData: RouteTableRow[];
  onDownload: (url: string, fileName: string) => void;
  onSaveComment: (locationId: number, comment: string) => void;
}

const RouteLocationsTable = ({ tableData, onDownload, onSaveComment }: RouteLocationsTableProps): JSX.Element => {
  const columns = getRouteColumns({ onDownload, onSaveComment });

  return (
    <div className="mg-t-20 w-100">
      <Space direction="vertical" size={12} className="w-100">
        <h4 className="fw-600">Route Locations</h4>
        <Table size="small" columns={columns} dataSource={tableData} pagination={false} scroll={{ y: 300 }} />
      </Space>
    </div>
  );
};

export default RouteLocationsTable;
